import { get } from 'lodash';

// Note: The name of this constraint is misleading, it enforces MMDDYYYY date formatting on a text input
export default {
  validate: (question, visible, answers, payload, config, ln) => {
    const answerInput = get(answers[question.id], 'input');
    const regex = /^(\d{2})(\d{2})(\d{4})$/;
    const valid = !answerInput || regex.test(answerInput);

    return {
      valid,
      messaging: valid ? null : {
        message:  (config.features.useDateFormatText[ln] || config.features.useDateFormatText['en_US']),
        displayBeforeSubmission: true,
        displayAboveControl: true
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/base/scripts/constraints/ValidateField.js